module.exports = __webpack_public_path__ + "6b55a75ce00012f60fe79857a9aa4df1.pdf";